import React from 'react';
import { Link } from 'react-router-dom';

import '../stylesheets/bloger.scss';



class Bloger extends React.Component {
  constructor(props) {
    super(props);
    this.imageGrayScale = React.createRef();
    this.animationHover = React.createRef();
  };
  handleMouseEnter = () => {
    if (this.animationHover.current) {
      const description = this.animationHover.current;
      description.className = 'bloger-item-counter-visible';
    };
    if (this.imageGrayScale.current) {
      const image = this.imageGrayScale.current;
      image.style.filter = 'grayscale(1)';
    }
  };
  handleMouseLeave = () => {
    if (this.animationHover.current) {
      const description = this.animationHover.current;
      description.className = 'bloger-item-counter-hidden';
    };
    if (this.imageGrayScale.current) {
      const image = this.imageGrayScale.current;
      image.style.filter = 'grayscale(0.1)';
    }
  };
  render() {
    return (
      <div className='bloger-item-container'>
        <img
          className='bloger-item-image'
          src={this.props.src}
          alt={this.props.alt}
          ref={this.imageGrayScale}
        />
        <div className='bloger-item-description-container'>
          <div 
            className='bloger-item-description'
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            >
            <div className='bloger-item-author'>
              <h3>{this.props.author}</h3>
            </div>
            <div className='bloger-item-title'>
              <Link to='/blog'>
                <h3>{this.props.title}</h3>
              </Link>
            </div>
            <div className='bloger-item-text'>
              <h4>{this.props.text}</h4>
            </div>
            <ul
              className='bloger-item-counter-hidden'
              ref={this.animationHover}
            >
              <li>
                <i className='fa fa-clock-o' />
                <h6>{this.props.date}</h6>
              </li>
              <li>
                <i className='fa fa-comments' />
                <h6>{this.props.comments}</h6>
              </li>
              <li>
                <i className='fa-solid fa-heart' /> 
                <h6>{this.props.likes}</h6>
              </li>
            </ul>
          </div>
        </div> 
      </div> 
    )
  }
}

export default Bloger;